// extracted by mini-css-extract-plugin
export default {"container":"Xp-z","heading":"Yp-z","text":"Zp-z","info":"_p-z","link":"aq-z","fullMaxWidth":"bq-z"};